import React, { useContext } from "react";
import { Link, useParams } from "react-router-dom";
import { GlobalContext } from "../contexts/GlobalContext";

const VacancyDetail = () => {
  const { id } = useParams();
  const { state } = useContext(GlobalContext);
  const { data } = state;

  //  Searching
  //  bisa di hapus
  console.log("vacancydetail");
  console.log(data);
  console.log(data[0].title);
  const job = data.find((job) => job.id === parseInt(id));

  if (!job) {
    return <p>Loading...</p>;
  }

  return (
    <div className="container mx-auto mt-10 p-8 bg-white shadow-md rounded-lg">
      <div className="flex mb-8">
        <div className="w-1/3 flex-shrink-0">
          <img
            src={job.company_image_url}
            alt={job.company_name}
            className="w-full h-auto rounded-lg"
          />
        </div>
        <div className="w-2/3 pl-8">
          <h1 className="text-4xl font-bold text-blue-700 mb-4">{job.title}</h1>
          <p className="text-lg text-gray-600 mb-2">{job.job_description}</p>
          <p className="text-lg text-gray-600 mb-2">{job.job_qualification}</p>
          <p className="text-lg text-gray-600 mb-2">{job.job_type}</p>
          <p className="text-lg text-gray-600 mb-2">{job.job_tenure}</p>
          {job.job_status === 1 ? (
            <p className="text-green-600 font-semibold mb-2">di Buka</p>
          ) : (
            <p className="text-red-600 font-semibold mb-2">di Tutup</p>
          )}
          <p className="text-xl font-semibold mt-4">{job.company_name}</p>
          <p className="text-lg text-gray-500">{job.company_city}</p>
          <p className="text-lg font-semibold mt-4">
            Salary:{" "}
            <span className="text-blue-600">
              {job.salary_min} - {job.salary_max}
            </span>
          </p>
        </div>
      </div>

      <div className="flex space-x-4">
        <Link to="/Vacancy">
          <button className="text-blue-500 border border-blue-500 hover:bg-blue-500 hover:text-white font-medium rounded-lg text-sm px-5 py-2.5 focus:ring-4 focus:outline-none focus:ring-blue-300">
            Back to Vacancy
          </button>
        </Link>
        <Link to="/Apply">
          <button
            type="button"
            className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:from-purple-600 hover:to-blue-500 font-medium rounded-lg text-sm px-5 py-2.5 focus:ring-4 focus:outline-none focus:ring-blue-300"
          >
            Apply Now
          </button>
        </Link>
      </div>
    </div>
  );
};

export default VacancyDetail;
